import { useSearchParams } from "react-router-dom";
import { useAgentBySlug, AgentProfile } from "@/hooks/useAgentBySlug";

interface AgentBrandingResult {
  brandedAgent: AgentProfile | null;
  isBranded: boolean;
  isLoading: boolean;
  agentSlug: string | null;
}

export function useAgentBranding(): AgentBrandingResult {
  const [searchParams] = useSearchParams();
  const agentSlug = searchParams.get("agent") || null;

  const { data: agent, isLoading } = useAgentBySlug(agentSlug ?? undefined);

  return {
    brandedAgent: agent ?? null,
    isBranded: !!agent,
    isLoading: !!agentSlug && isLoading,
    agentSlug,
  };
}

export default useAgentBranding;
